import {
  FETCHING_USER_ACCOUNT_REQUEST, FETCHING_USER_ACCOUNT_SUCCEDDED, FETCHING_USER_ACCOUNT_FAILED,
  FETCHING_USER_PROFILE, FETCHING_USER_PROFILE_SUCCEEDED, FETCHING_USER_PROFILE_FAILED,
  LOGOUT_USER,
  FETCHING_NOTIFICATIONS_FAILED,
  FETCHING_NOTIFICATIONS,
  FETCHING_NOTIFICATIONS_SUCCEEDED,
  AUTHENTICATE_USER_SUCCEEDED
} from 'constants/actionTypes.jsx';

import AuthService from '../services/auth.service.js';

const initialState = { 
  account: {
    item: null,
    loading: false,
    error: null
  },
  profile: {
    item: null,
    loading: false,
    error: null
  },
  recipients: "",
  logout: false,
}

function usersReducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_USER_ACCOUNT_REQUEST:
      return {
        ...state,
        account: {
          loading: true
        }
      }
    case FETCHING_USER_ACCOUNT_SUCCEDDED:
      return {
        ...state,
        account: {
          loading: false,
          item: action.payload,
          error: null
        },
        logout: false
      }
    case FETCHING_USER_ACCOUNT_FAILED:
      return {
        ...state,
        account: {
          loading: false,
          item: null,
          error: action.payload
        }
      }
    case FETCHING_USER_PROFILE:
      return {
        ...state,
        profile: {
          loading: true
        }
      }
    case FETCHING_USER_PROFILE_SUCCEEDED:
      return {
        ...state,
        profile: {
          loading: false,
          item: action.payload,
          error: null
        },
        logout: false
      }
    case FETCHING_USER_PROFILE_FAILED:
      return {
        ...state,
        profile: {
          loading: false,
          item: null,
          error: action.payload
        }
      }
    case FETCHING_NOTIFICATIONS:
      return {
        ...state,
        notification: {
          ...state.notification,
          loading: true,
        }
      }
    case FETCHING_NOTIFICATIONS_SUCCEEDED:
      const { currentPage, recordsPerPage, totalPages, totalRecordsCount } = action.payload.response;
      let items = [];
      if (currentPage === 0) {
        items = action.payload.response.records
      }
      else {
        items = [...state.notification.items,...action.payload.response.records]
      }
      return {
        ...state,
        notification: {
          loading: false,
          items,
          pagination: {
            currentPage,
            recordsPerPage,
            totalPages,
            totalRecordsCount
          }
        }
      }
    case FETCHING_NOTIFICATIONS_FAILED:
      return {
        ...state,
        notification: {
          loading: false,
          item: null,
          error: action.payload
        }
      }
    case LOGOUT_USER:
      return {
        ...state,
        logout: true
      }

    case AUTHENTICATE_USER_SUCCEEDED:
      return {
        ...state,
        logout: false
      }

    default:
      return state
  }
}

export { usersReducer };